import React, { useEffect, useState } from "react";
import DivisionCmp from "../../../components/cards/DivisionCmp";

import DetailInfoComponent from "../../../components/detailInfo/detailInfoComponent";
import { SectionModel } from "../../../models/components.model";
import { ChequeGuarantyInfo } from "../../../models/loan.model";
import DocumentInfoComponent from "../../../components/detailInfo/documentInfoComponent";
import { InfoCheque } from "../../../models/cartable.model";
import DocumentInfoComponentSingle from "../../../components/detailInfo/documentInfoComponentSingle";
import * as Converter from "persian-currency-converter";
import Grid from "@mui/material/Grid";
import DownloaderCmp from "../../../components/detailInfo/downloderCmp";

export default function ContractInfo(props: any) {
  return (
    <>
      <Grid container xs={12} spacing={2} columns={{ xs: 2, sm: 8, md: 12 }}>
        {props?.data?.map((item: any, index: number) => (
          <Grid item xs={2}>
            <DownloaderCmp data={item} />
          </Grid>
        ))}
      </Grid>
    </>
  );
  // <DocumentInfoComponentSingle data={props} />
}
